import API from '@Services/apiAxios';
import axios from 'axios';
import { pollExtraction, unwrapExtractionResponse } from './extractionService';

export const uploadExcelData = async (csvContent: string): Promise<any> => {
  const response = await API.post('/speedboxbot/extract', {
    documentType: 'shipment',
    textContent: csvContent,
    mode: 'async',
  });
  const data = unwrapExtractionResponse(response.data);
  if (data?.jobId && (data?.status === 'pending' || data?.status === 'processing')) {
    return await pollExtraction(data);
  }
  return data;
};

export interface PresignedUrlResponse {
  url: string;
  fields: Record<string, string>;
  key: string;
}

export interface PresignedUrlsResponse {
  batchId: string;
  files: PresignedUrlResponse[];
}

export const getUploadUrl = async (file: File): Promise<PresignedUrlResponse> => {
  const { data } = await API.post<PresignedUrlResponse>('/speedboxbot/extract/upload-url', {
    fileName: file.name,
    mimeType: file.type,
  });
  return data;
};

export const getUploadUrls = async (
  files: { fileName: string; mimeType: string }[],
): Promise<PresignedUrlsResponse> => {
  const { data } = await API.post<PresignedUrlsResponse>('/speedboxbot/extract/upload-urls', {
    files,
  });
  return data;
};

export const uploadToS3 = async (uploadUrlResponse: PresignedUrlResponse, file: File): Promise<void> => {
  const { url, fields } = uploadUrlResponse;
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  // Use a clean axios instance for the S3 POST request to avoid custom API headers
  await axios.post(url, formData);
};
